export const TARIFFS = {
  OBO_JE: 8,
  OBO_MA: 9,
  // nové produkty od 1.1.2023
  OBO_JE_2023: 10,
  OBO_MA_2023: 11,
  OBO_SZ_2023: 12,
  // lifeway
  OBO_LW: 16,
  // novy zivot
  NZ1: 10,
  NZ1MA: 11,
  NZ2: 17,
  NZ3: 18,
};
